import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Shows a celebratory banner when the admin has flipped global "free mode" on. */
export default function FreeModeBanner({ className = "" }) {
  const [free, setFree] = useState(false);

  useEffect(() => {
    axios.get(`${API}/config/public`).then((r) => setFree(!!r.data?.free_mode)).catch(() => {});
  }, []);

  if (!free) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className={`relative overflow-hidden rounded-2xl px-5 py-4 sm:px-7 sm:py-5 ${className}`}
      style={{ background: "linear-gradient(135deg,#7C5CFF 0%,#5AC8FA 100%)", boxShadow: "0 16px 50px -14px rgba(124,92,255,0.65)" }}
      data-testid="free-mode-banner"
    >
      <div className="absolute -top-10 -right-6 w-40 h-40 rounded-full bg-white/20 blur-3xl pointer-events-none" />
      <div className="relative flex items-center gap-3 sm:gap-4">
        <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center flex-shrink-0">
          <Sparkles size={20} className="text-white" />
        </div>
        <div>
          <p className="text-white font-bold text-[15px] sm:text-[17px] leading-tight">Everything is free, for now 🎉</p>
          <p className="text-white/90 text-[12.5px] sm:text-[13.5px] mt-0.5">
            Every Plus &amp; Pro feature is unlocked for all users — no payment needed. Enjoy it while it lasts!
          </p>
        </div>
      </div>
    </motion.div>
  );
}
